import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import { PATH } from '../../constants/path';
import { HIDE_NAV_MENU } from '../../constants';

import headerService from '../../services/header';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import { Logo } from '../icons/Logo';
import SearchComponent from './search/SearchComponent';
import LocalizedNavLink from '../router/LocalizedNavLink';
import MemberNavComponent from './membernav/MemberNavComponent';
import MobileMemberNavComponent from './membernav/MobileMemberNavComponent';
import AllCategoriesMenuComponent from './AllCategoriesMenuComponent';
import MobileCategoriesMenuComponent from './MobileCategoriesMenuComponent';

import './HeaderComponent.scss';

class HeaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stateOpenMenuMobileSlide: false,
            searchFocused: false
        };
    }

    // Desktop : quand la recherche a le focus, le bouton "Toutes les
    // catégories" passe en version compacte (flèche seule) et la barre de
    // recherche s'étend sur l'espace libéré.
    onSearchFocus = () => this.setState({ searchFocused: true });
    onSearchBlur = () => this.setState({ searchFocused: false });

    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MENU_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const {
            user,
            isAuthenticated,
            fetching,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            hideNav,
            hideSearch,
            BRAND_NAME,
            LOGO_TITLE,
            i18nAccessibility
        } = this.props;

        return (
            <header
                className={`tetedepage conteneur flex-container-h flex-center-alt ${
                    hideSearch ? 'hideSearch' : ''
                }`}
                role="banner">
                <LocalizedNavLink
                    to={PATH.HOME_PATH}
                    title={convertHtmlToReactDomWithParams(LOGO_TITLE, BRAND_NAME)}
                    className="logo">
                    <Logo />
                </LocalizedNavLink>
                {!hideNav && <AllCategoriesMenuComponent compact={this.state.searchFocused} />}
                {!hideSearch && (
                    <SearchComponent
                        stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                        versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                        onSearchFocus={this.onSearchFocus}
                        onSearchBlur={this.onSearchBlur}
                    />
                )}
                <MemberNavComponent
                    user={user}
                    isAuthenticated={isAuthenticated}
                    fetching={fetching}
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                />
                <MobileMemberNavComponent
                    isAuthenticated={isAuthenticated}
                    stateOpenMenuMobileSlide={stateOpenMenuMobileSlide}
                    versionOpenMenuMobileSlide={versionOpenMenuMobileSlide}
                    onClickBtMenuMobile={this.onClickBtMenuMobile}
                    hideNav={hideNav}
                />
                {!hideNav && !HIDE_NAV_MENU && (
                    <button
                        className={`menu-mobile-bt menu-mobile-bt-listener ${
                            stateOpenMenuMobileSlide ? 'open' : 'closed'
                        }`}
                        id="menu-mobile-bt"
                        data-target="menu"
                        onClick={this.onClickBtMenuMobile.bind(this)}>
                        <span />
                        <span className="sr-only">
                            {stateOpenMenuMobileSlide
                                ? i18nAccessibility.NAV_MENU_BUTTON_CLOSE
                                : i18nAccessibility.NAV_MENU_BUTTON_OPEN}
                        </span>
                    </button>
                )}
                {!hideNav && HIDE_NAV_MENU && <MobileCategoriesMenuComponent />}
            </header>
        );
    }
}

HeaderComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    hideNav: PropTypes.bool,
    hideSearch: PropTypes.bool
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        isAuthenticated: state.authentication.isAuthenticated,
        fetching: state.authentication.fetching,
        user: toPlainObject(state.account.user),
        location: state.routing.location,
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        LOGO_TITLE: state.i18n.feature.header.LOGO_TITLE,
        i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY
    };
}

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js